//utility function to safely parse dates  // Helper function to parse MM/DD/YYYY format
export const parseDateString = (dateString) => {
  if (!dateString) return "";

  // Handle MM/DD/YYYY format
  if (dateString.includes("/")) {
    const [month, day, year] = dateString.split("/");
    // Note: month - 1 because JavaScript months are 0-based
    return new Date(year, parseInt(month) - 1, day).toISOString().split("T")[0];
  }
  return dateString;
};

// Modify the formatDisplayDate function
export // Format date for display
const formatDisplayDate = (dateString) => {
  if (!dateString) return "";

  try {
    if (dateString.includes("/")) {
      const [month, day, year] = dateString.split("/");
      return `${month}/${day}/${year}`;
    }

    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  } catch (error) {
    console.error("Date formatting error:", error);
    return dateString;
  }
};

export const convertDateFormat_agent = (dateString) => {
  if (!dateString) return "";

  try {
    // Handle YYYY-MM-DD format
    if (dateString.includes("-")) {
      const [year, month, day] = dateString.split("-");
      return `${month}/${day}/${year}`;
    }

    // Handle MM/DD/YYYY format
    const [month, day, year] = dateString.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  } catch (error) {
    console.error("Error converting date:", error);
    return dateString; // Return original string if conversion fails
  }
};

// Function to convert date from MM/DD/YYYY to YYYY-MM-DD
export const convertMMDDYYtoYYYYMMDD = (dateString) => {
  if (!dateString) return "";
  const [month, day, year] = dateString.split("/");
  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
};

// Function to convert date from YYYY-MM-DD to MM/DD/YYYY
export const convertYYYYMMDDtoMMDDYYYY = (dateString) => {
  if (!dateString) return "";
  const [year, month, day] = dateString.split("-");
  return `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
};
